<igo-time-filter-item
  [layer]="layer"
  [header]="false"
  [@toolSlideInOut]="animate"
/>
